/**
 * Shared filename allowlist for all portal upload paths (portal file uploads,
 * 2-way messaging, and order request uploads). Permits letters, numbers, spaces,
 * and common punctuation found in real-world filenames while blocking characters
 * that are unsafe in a CloudFront signed-policy URL: # * ? \ % and path traversal.
 * Applied consistently so the effective policy is the strictest one across all
 * ingress points.
 *
 * Explicitly blocked (not in allowlist): # * ? \ % / and .. segments.
 * Explicitly allowed beyond alphanumeric: _ - ( ) + & @ ! ' , . and space.
 */
export const VALID_FILENAME_PATTERN = /^[A-Za-z0-9_+&@!',()\- ]+(\.[A-Za-z0-9_+&@!',()\- ]+)*$/
